// Дни недели и месяцы для локализации дат
const dateLocalization = {
  en: {
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  },
  ru: {
    days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    months: ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря']
  },
  ka: {
    days: ['კვირა', 'ორშაბათი', 'სამშაბათი', 'ოთხშაბათი', 'ხუთშაბათი', 'პარასკევი', 'შაბათი'],
    months: ['იანვარი', 'თებერვალი', 'მარტი', 'აპრილი', 'მაისი', 'ივნისი', 'ივლისი', 'აგვისტო', 'სექტემბერი', 'ოქტომბერი', 'ნოემბერი', 'დეკემბერი']
  }
};

const translations = {
  en: {
    appTitle: "Handyman - master services booking",
    welcome: "Welcome to Handyman service!",
    findMasters: "Here you can find masters for various tasks.",
    mastersList: "Masters List",
    pageNotFound: "Page not found",
    goToMasters: "Go to Masters List",
    loading: "Loading...",
    error: "Error",
    firstName: "First Name",
    phone: "Phone Number",
    mastersNotFound: "No masters found",
    details: "Details",
    backToList: "← Back to masters list",
    address: "Address",
    bookingInterval: "Booking interval",
    description: "Description",
    services: "Services",
    noServices: "This master has no available services",
    duration: "Duration",
    min: "min.",
    selectService: "Select service",
    scheduleForService: "Schedule for service",
    scheduleWillBeHere: "Available booking time schedule will be here.",
    inDevelopment: "Feature is under development.",
    noAvailableSlots: "No available time slots for this service",
    bookingFeatureInDevelopment: "Booking feature is under development",
    masterOrders: "My Orders",
    statusPending: "Pending",
    statusConfirmed: "Confirmed",
    statusCancelled: "Cancelled",
    statusCompleted: "Completed",
    markCompleted: "Mark as Completed",
    client: "Client",
    service: "Service",
    contact: "Contact",
    noEmail: "No email provided",
    noPhone: "No phone number",
    filterByDate: "Filter by date",
    clearFilter: "Clear filter",
    accessDenied: "Access Denied",
    errorFetchingBookings: "Error loading bookings",
    errorUpdatingStatus: "Error updating status",
    unknownUser: "Unknown User",
    unknownService: "Unknown Service",
    appointmentTime: "Appointment Time",
    noBookingsYet: "You have no bookings yet",
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm password",
    loginError: "Login failed. Please check your credentials.",
    registrationError: "Registration failed. Please try again.",
    passwordsNotMatch: "Passwords do not match",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    pleaseLoginToBook: "Please login to book this service",
    bookingSuccessful: "Booking successful!",
    bookingFailed: "Booking failed. Please try again.",
    bookingConfirmation: "Booking Confirmation",
    bookNow: "Book Now",
    confirmBooking: "Confirm Booking",
    cancelBooking: "Cancel Booking",
    stillThinking: "I'll think about it",
    ok: "OK",
    bookingSuccessMessage: "Your appointment has been successfully booked.",
    // New booking-related translations
    menu: "Menu",
    home: "Home",
    myBookings: "My Appointments",
    noBookings: "You have no scheduled appointments",
    noPendingBookings: "No bookings waiting for confirmation",
    pendingOrders: "Pending Orders",
    master: "Master",
    when: "Date and Time",
    price: "Price",
    minutes: "minutes",
    hour: "hour",
    hours: "hours",
    serviceLabel: "Service",
    masterLabel: "Master",
    dateTimeLabel: "Date and time",
    durationLabel: "Duration",
    // Booking status translations (lowercase for frontend)
    pending: "Created",
    scheduled: "Scheduled", 
    completed: "Completed",
    cancelled: "Cancelled",
    // Capitalized status values from backend
    Pending: "Created",
    Scheduled: "Scheduled",
    Completed: "Completed", 
    Cancelled: "Cancelled",
    confirmStatusChange: "Confirm Status Change",
    confirmScheduleBooking: "Are you sure you want to confirm this appointment?",
    confirmCompleteBooking: "Are you sure you want to mark this appointment as completed?",
    confirmCancelBooking: "Are you sure you want to cancel this appointment? This action cannot be undone.",
    errorCancelingBooking: "Error canceling the appointment",
    yes: "Yes",
    no: "No",
    // Schedule management translations
    scheduleManagement: "Schedule Management",
    workingHours: "Working Hours",
    breaks: "Breaks",
    addWorkingHours: "Add Working Hours",
    addBreak: "Add Break",
    daysOfWeek: "Days of week",
    startTime: "Start Time",
    endTime: "End Time",
    startDate: "Start Date",
    endDate: "End Date",
    optional: "optional",
    save: "Save",
    update: "Update",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    yourWorkingHours: "Your Working Hours",
    yourBreaks: "Your Breaks",
    days: "Days",
    time: "Time",
    dateRange: "Date Range",
    actions: "Actions",
    noWorkingHours: "No working hours defined yet. Add your first schedule!",
    noBreaks: "No breaks defined yet. Add your first break!",
    schedulePreview: "Schedule Preview",
    selectDatePreview: "Select a date to see your available slots based on your working hours and breaks",
    availableSlotsFor: "Available Slots for",
    loadingSlots: "Loading slots...",
    noAvailableSlotsForDate: "No available slots for this date",
    always: "Always",
    forever: "Forever",
    confirmDeleteRule: "Are you sure you want to delete this rule?",
    failedToLoadSchedule: "Failed to load schedule data",
    failedToSaveRule: "Failed to save rule",
    failedToDeleteRule: "Failed to delete rule",
    pleaseSelectDay: "Please select at least one day of the week",
    endTimeMustBeAfterStart: "End time must be after start time",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    Sunday: "Sunday",
    serviceManagement: "Service Management",
    myServices: "My Services",
    addService: "Add Service",
    editService: "Edit Service",
    noServicesYet: "You have no services yet. Add your first service!",
    serviceName: "Service Name",
    serviceNameEn: "Service Name (English)",
    serviceNameRu: "Service Name (Russian)",
    serviceNameKa: "Service Name (Georgian)",
    serviceDuration: "Duration (minutes)",
    serviceDescription: "Description",
    serviceDescriptionEn: "Description (English)",
    serviceDescriptionRu: "Description (Russian)",
    serviceDescriptionKa: "Description (Georgian)",
    englishRequired: "English name is required",
    durationMustBeInteger: "Duration must be a whole number",
    priceMustBeInteger: "Price must be a whole number",
    servicePrice: "Price",
    confirmDeleteService: "Are you sure you want to delete this service?",
    fieldRequired: "This field is required",
    validDurationRequired: "Duration must be greater than 0",
    serviceAddSuccess: "Service was successfully added",
    serviceUpdateSuccess: "Service was successfully updated",
    serviceDeleteSuccess: "Service was successfully deleted",
    masterNote: "Master Note",
    addBooking: "Add Booking",
    masterNoteLabel: "Note",
    masterNotePlaceholder: "Add notes about this booking (required)",
    masterNoteRequired: "Please add a note for this booking",
    termsAgreement: "I have read and agree to the",
    termsOfService: "terms of service",
    termsAgreementRequired: "You must agree to the terms of service"
  },
  ru: {
    appTitle: "Handyman - заказ услуг мастеров",
    welcome: "Добро пожаловать в сервис Handyman!",
    findMasters: "Здесь вы можете найти мастеров для выполнения различных работ.",
    mastersList: "Список мастеров",
    pageNotFound: "Страница не найдена",
    goToMasters: "Перейти к списку мастеров",
    loading: "Загрузка...",
    error: "Ошибка",
    firstName: "Имя",
    phone: "Телефон",
    mastersNotFound: "Мастера не найдены",
    details: "Подробнее",
    backToList: "← Назад к списку мастеров",
    address: "Адрес",
    bookingInterval: "Интервал брони",
    description: "Описание",
    services: "Услуги",
    noServices: "У данного мастера нет доступных услуг",
    duration: "Длительность",
    min: "мин.",
    selectService: "Выбрать услугу",
    scheduleForService: "Расписание для услуги",
    scheduleWillBeHere: "Здесь будет расписание доступного времени для записи.",
    inDevelopment: "Функция находится в разработке.",
    noAvailableSlots: "Нет доступного времени для этой услуги",
    bookingFeatureInDevelopment: "Функция бронирования находится в разработке",
    masterOrders: "Мои заказы",
    statusPending: "Ожидает",
    statusConfirmed: "Подтверждено",
    statusCancelled: "Отменено",
    statusCompleted: "Завершено",
    markCompleted: "Отметить как выполненное",
    client: "Клиент",
    service: "Услуга",
    contact: "Контакт",
    noEmail: "Email не указан",
    noPhone: "Нет номера телефона",
    filterByDate: "Фильтр по дате",
    clearFilter: "Очистить фильтр",
    accessDenied: "Доступ запрещен",
    errorFetchingBookings: "Ошибка при загрузке записей",
    errorUpdatingStatus: "Ошибка при обновлении статуса",
    unknownUser: "Неизвестный пользователь",
    unknownService: "Неизвестная услуга",
    appointmentTime: "Время записи",
    noBookingsYet: "У вас пока нет бронирований",
    login: "Войти",
    register: "Регистрация",
    logout: "Выйти",
    email: "Email",
    password: "Пароль",
    confirmPassword: "Подтверждение пароля",
    loginError: "Ошибка входа. Пожалуйста, проверьте данные.",
    registrationError: "Ошибка регистрации. Пожалуйста, попробуйте снова.",
    passwordsNotMatch: "Пароли не совпадают",
    noAccount: "Нет аккаунта?",
    haveAccount: "Уже есть аккаунт?",
    pleaseLoginToBook: "Пожалуйста, войдите в систему для бронирования",
    bookingSuccessful: "Бронирование успешно!",
    bookingFailed: "Ошибка бронирования. Попробуйте еще раз.",
    bookingConfirmation: "Подтверждение записи",
    bookNow: "Записаться",
    confirmBooking: "Подтвердить",
    cancelBooking: "Отменить запись",
    stillThinking: "Я еще подумаю",
    ok: "ОК",
    bookingSuccessMessage: "Ваша запись успешно создана.",
    // New booking-related translations
    menu: "Меню",
    home: "Главная",
    myBookings: "Мои записи",
    noBookings: "У вас нет запланированных записей",
    noPendingBookings: "Нет заявок, ожидающих подтверждения",
    pendingOrders: "Ожидающие заказы",
    master: "Мастер",
    when: "Дата и время",
    price: "Цена",
    minutes: "минут",
    hour: "час",
    hours: "часа",
    serviceLabel: "Услуга",
    masterLabel: "Мастер",
    dateTimeLabel: "Дата и время",
    durationLabel: "Длительность",
    // Booking status translations (lowercase for frontend)
    pending: "Создано",
    scheduled: "Запланировано",
    completed: "Выполнено",
    cancelled: "Отменено",
    // Capitalized status values from backend
    Pending: "Создано",
    Scheduled: "Запланировано",
    Completed: "Выполнено",
    Cancelled: "Отменено",
    confirmStatusChange: "Подтвердите изменение статуса",
    confirmScheduleBooking: "Вы уверены, что хотите подтвердить эту запись?",
    confirmCompleteBooking: "Вы уверены, что хотите отметить эту запись как выполненную?",
    confirmCancelBooking: "Вы уверены, что хотите отменить эту запись? Это действие нельзя отменить.",
    errorCancelingBooking: "Ошибка при отмене записи",
    yes: "Да",
    no: "Нет",
    // Schedule management translations
    scheduleManagement: "Управление расписанием",
    workingHours: "Рабочее время",
    breaks: "Перерывы",
    addWorkingHours: "Добавить рабочее время",
    addBreak: "Добавить перерыв",
    daysOfWeek: "Дни недели",
    startTime: "Время начала",
    endTime: "Время окончания",
    startDate: "Дата начала",
    endDate: "Дата окончания",
    optional: "необязательно",
    save: "Сохранить",
    update: "Обновить",
    cancel: "Отмена",
    edit: "Изменить",
    delete: "Удалить",
    yourWorkingHours: "Ваше рабочее время",
    yourBreaks: "Ваши перерывы",
    days: "Дни",
    time: "Время",
    dateRange: "Диапазон дат",
    actions: "Действия",
    noWorkingHours: "Рабочее время еще не определено. Добавьте свое первое расписание!",
    noBreaks: "Перерывы еще не определены. Добавьте свой первый перерыв!",
    schedulePreview: "Предпросмотр расписания",
    selectDatePreview: "Выберите дату, чтобы увидеть ваши доступные слоты на основе рабочего времени и перерывов",
    availableSlotsFor: "Доступные слоты на",
    loadingSlots: "Загрузка слотов...",
    noAvailableSlotsForDate: "Нет доступных слотов на эту дату",
    always: "Всегда",
    forever: "Бессрочно",
    confirmDeleteRule: "Вы уверены, что хотите удалить это правило?",
    failedToLoadSchedule: "Не удалось загрузить данные расписания",
    failedToSaveRule: "Не удалось сохранить правило",
    failedToDeleteRule: "Не удалось удалить правило",
    pleaseSelectDay: "Пожалуйста, выберите хотя бы один день недели",
    endTimeMustBeAfterStart: "Время окончания должно быть позже времени начала",
    Monday: "Понедельник",
    Tuesday: "Вторник",
    Wednesday: "Среда",
    Thursday: "Четверг",
    Friday: "Пятница",
    Saturday: "Суббота",
    Sunday: "Воскресенье",
    serviceManagement: "Управление услугами",
    myServices: "Мои услуги",
    addService: "Добавить услугу",
    editService: "Изменить услугу",
    noServicesYet: "У вас пока нет услуг. Добавьте свою первую услугу!",
    serviceName: "Название услуги",
    serviceNameEn: "Название услуги (Английский)",
    serviceNameRu: "Название услуги (Русский)",
    serviceNameKa: "Название услуги (Грузинский)",
    serviceDuration: "Продолжительность (минуты)",
    serviceDescription: "Описание",
    serviceDescriptionEn: "Описание (Английский)",
    serviceDescriptionRu: "Описание (Русский)",
    serviceDescriptionKa: "Описание (Грузинский)",
    englishRequired: "Английское название обязательно",
    durationMustBeInteger: "Продолжительность должна быть целым числом",
    priceMustBeInteger: "Цена должна быть целым числом",
    servicePrice: "Цена",
    confirmDeleteService: "Вы уверены, что хотите удалить эту услугу?",
    fieldRequired: "Это поле обязательно",
    validDurationRequired: "Продолжительность должна быть больше 0",
    serviceAddSuccess: "Услуга успешно добавлена",
    serviceUpdateSuccess: "Услуга успешно обновлена",
    serviceDeleteSuccess: "Услуга успешно удалена",
    failedToLoadServices: "Не удалось загрузить услуги",
    failedToSaveService: "Не удалось сохранить услугу",
    failedToDeleteService: "Не удалось удалить услугу",
    masterNote: "Заметка мастера",
    addBooking: "Добавить запись",
    masterNoteLabel: "Заметка",
    masterNotePlaceholder: "Добавьте заметку к этой записи (обязательно)",
    masterNoteRequired: "Пожалуйста, добавьте заметку к записи",
    termsAgreement: "Я прочитал и согласен с",
    termsOfService: "условиями использования сайта",
    termsAgreementRequired: "Необходимо согласиться с условиями использования сайта"
  },
  ka: {
    appTitle: "Handyman - ოსტატების მომსახურების დაჯავშნა",
    welcome: "კეთილი იყოს თქვენი მობრძანება Handyman სერვისში!",
    findMasters: "აქ შეგიძლიათ იპოვოთ ოსტატები სხვადასხვა სამუშაოებისთვის.",
    mastersList: "ოსტატების სია",
    pageNotFound: "გვერდი ვერ მოიძებნა",
    goToMasters: "ოსტატების სიაში გადასვლა",
    loading: "იტვირთება...",
    error: "შეცდომა",
    firstName: "სახელი",
    phone: "ტელეფონი",
    mastersNotFound: "ოსტატები ვერ მოიძებნა",
    details: "დეტალები",
    backToList: "← უკან ოსტატების სიაში",
    address: "მისამართი",
    bookingInterval: "ჯავშნის ინტერვალი",
    description: "აღწერა",
    services: "მომსახურება",
    noServices: "ამ ოსტატს არ აქვს ხელმისაწვდომი მომსახურება",
    duration: "ხანგრძლივობა",
    min: "წთ.",
    selectService: "მომსახურების არჩევა",
    scheduleForService: "განრიგი მომსახურებისთვის",
    scheduleWillBeHere: "აქ იქნება ხელმისაწვდომი დროის განრიგი ჯავშნისთვის.",
    inDevelopment: "ფუნქცია დამუშავების პროცესშია.",
    noAvailableSlots: "ამ სერვისის ხელმისაწვდომი დრო არ არის",
    bookingFeatureInDevelopment: "ჯავშნის ფუნქცია დამუშავების პროცესშია",
    masterOrders: "ჩემი შეკვეთები",
    statusPending: "მოლოდინში",
    statusConfirmed: "დადასტურებული",
    statusCancelled: "გაუქმებული",
    statusCompleted: "დასრულებული",
    markCompleted: "მონიშნეთ როგორც დასრულებული",
    client: "კლიენტი",
    service: "სერვისი",
    contact: "კონტაქტი",
    noEmail: "ელფოსტა არ არის მითითებული",
    noPhone: "ტელეფონის ნომერი არ არის",
    filterByDate: "გაფილტვრა თარიღით",
    clearFilter: "ფილტრის გასუფთავება",
    accessDenied: "წვდომა აკრძალულია",
    errorFetchingBookings: "ჯავშნების ჩატვირთვის შეცდომა",
    errorUpdatingStatus: "სტატუსის განახლების შეცდომა",
    unknownUser: "უცნობი მომხმარებელი",
    unknownService: "უცნობი სერვისი",
    appointmentTime: "შეხვედრის დრო",
    noBookingsYet: "თქვენ ჯერ არ გაქვთ ჯავშნები",
    login: "შესვლა",
    register: "რეგისტრაცია",
    logout: "გასვლა",
    email: "ელფოსტა",
    password: "პაროლი",
    confirmPassword: "პაროლის დადასტურება",
    loginError: "შესვლის შეცდომა. გთხოვთ, შეამოწმეთ მონაცემები.",
    registrationError: "რეგისტრაციის შეცდომა. გთხოვთ, სცადეთ ხელახლა.",
    passwordsNotMatch: "პაროლები არ ემთხვევა",
    noAccount: "არ გაქვთ ანგარიში?",
    haveAccount: "უკვე გაქვთ ანგარიში?",
    pleaseLoginToBook: "გთხოვთ შეხვიდეთ სისტემაში დასაჯავშნად",
    bookingSuccessful: "ჯავშანი წარმატებულია!",
    bookingFailed: "ჯავშნის შეცდომა. გთხოვთ სცადოთ ხელახლა.",
    bookingConfirmation: "ჯავშნის დადასტურება",
    bookNow: "დაჯავშნა",
    confirmBooking: "დადასტურება",
    cancelBooking: "ჯავშნის გაუქმება",
    stillThinking: "მე ვფიქრობ",
    ok: "კარგი",
    bookingSuccessMessage: "თქვენი ჯავშანი წარმატებით დაჯავშნილია.",
    // New booking-related translations
    menu: "მენიუ",
    home: "მთავარი",
    myBookings: "ჩემი ჯავშნები",
    noBookings: "თქვენ არ გაქვთ დაგეგმილი ჯავშნები",
    noPendingBookings: "არ არის მოლოდინში შეკვეთები",
    pendingOrders: "მიმდინარე შეკვეთები",
    master: "ოსტატი",
    when: "თარიღი და დრო",
    price: "ფასი",
    minutes: "წუთი",
    hour: "საათი",
    hours: "საათი",
    serviceLabel: "სერვისი",
    masterLabel: "ოსტატი",
    dateTimeLabel: "თარიღი და დრო",
    durationLabel: "ხანგრძლივობა",
    // Booking status translations (lowercase for frontend)
    pending: "შექმნილი",
    scheduled: "დაგეგმილი",
    completed: "დასრულებული",
    cancelled: "გაუქმებული",
    // Capitalized status values from backend
    Pending: "შექმნილი",
    Scheduled: "დაგეგმილი",
    Completed: "დასრულებული",
    Cancelled: "გაუქმებული",
    confirmStatusChange: "დაადასტურეთ სტატუსის ცვლილება",
    confirmScheduleBooking: "დარწმუნებული ხართ, რომ გსურთ ამ ჯავშნის დადასტურება?",
    confirmCompleteBooking: "დარწმუნებული ხართ, რომ გსურთ ეს ჯავშანი დასრულებულად მონიშნოთ?",
    confirmCancelBooking: "დარწმუნებული ხართ, რომ გსურთ ამ ჯავშნის გაუქმება? ეს მოქმედება ვერ გაუქმდება.",
    errorCancelingBooking: "ჯავშნის გაუქმების შეცდომა",
    yes: "დიახ",
    no: "არა",
    // Schedule management translations
    scheduleManagement: "განრიგის მართვა",
    workingHours: "სამუშაო საათები",
    breaks: "შესვენებები",
    addWorkingHours: "სამუშაო საათების დამატება",
    addBreak: "შესვენების დამატება",
    daysOfWeek: "კვირის დღეები",
    startTime: "დაწყების დრო",
    endTime: "დასრულების დრო",
    startDate: "დაწყების თარიღი",
    endDate: "დასრულების თარიღი",
    optional: "არასავალდებულო",
    save: "შენახვა",
    update: "განახლება",
    cancel: "გაუქმება",
    edit: "რედაქტირება",
    delete: "წაშლა",
    yourWorkingHours: "თქვენი სამუშაო საათები",
    yourBreaks: "თქვენი შესვენებები",
    days: "დღეები",
    time: "დრო",
    dateRange: "თარიღების დიაპაზონი",
    actions: "ქმედებები",
    noWorkingHours: "სამუშაო საათები ჯერ არ არის განსაზღვრული. დაამატეთ თქვენი პირველი განრიგი!",
    noBreaks: "შესვენებები ჯერ არ არის განსაზღვრული. დაამატეთ თქვენი პირველი შესვენება!",
    schedulePreview: "განრიგის გადახედვა",
    selectDatePreview: "აირჩიეთ თარიღი, რომ ნახოთ თქვენი ხელმისაწვდომი სლოტები სამუშაო საათებისა და შესვენებების საფუძველზე",
    availableSlotsFor: "ხელმისაწვდომი სლოტები",
    loadingSlots: "სლოტების ჩატვირთვა...",
    noAvailableSlotsForDate: "ამ თარიღისთვის ხელმისაწვდომი სლოტები არ არის",
    always: "ყოველთვის",
    forever: "სამუდამოდ",
    confirmDeleteRule: "დარწმუნებული ხართ, რომ გსურთ ამ წესის წაშლა?",
    failedToLoadSchedule: "განრიგის მონაცემების ჩატვირთვა ვერ მოხერხდა",
    failedToSaveRule: "წესის შენახვა ვერ მოხერხდა",
    failedToDeleteRule: "წესის წაშლა ვერ მოხერხდა",
    pleaseSelectDay: "გთხოვთ, აირჩიოთ კვირის მინიმუმ ერთი დღე",
    endTimeMustBeAfterStart: "დასრულების დრო უნდა იყოს დაწყების დროის შემდეგ",
    serviceManagement: "სერვისების მართვა",
    myServices: "ჩემი სერვისები",
    addService: "სერვისის დამატება",
    editService: "სერვისის რედაქტირება",
    noServicesYet: "თქვენ ჯერ არ გაქვთ სერვისები. დაამატეთ თქვენი პირველი სერვისი!",
    serviceName: "სერვისის სახელი",
    serviceNameEn: "სერვისის სახელი (ინგლისური)",
    serviceNameRu: "სერვისის სახელი (რუსული)",
    serviceNameKa: "სერვისის სახელი (ქართული)",
    serviceDuration: "ხანგრძლივობა (წუთები)",
    serviceDescription: "აღწერა",
    serviceDescriptionEn: "აღწერა (ინგლისური)",
    serviceDescriptionRu: "აღწერა (რუსული)",
    serviceDescriptionKa: "აღწერა (ქართული)",
    englishRequired: "ინგლისური სახელი აუცილებელია",
    durationMustBeInteger: "ხანგრძლივობა უნდა იყოს მთელი რიცხვი",
    priceMustBeInteger: "ფასი უნდა იყოს მთელი რიცხვი",
    servicePrice: "ფასი",
    confirmDeleteService: "დარწმუნებული ხართ, რომ გსურთ ამ სერვისის წაშლა?",
    fieldRequired: "ეს ველი აუცილებელია",
    validDurationRequired: "ხანგრძლივობა უნდა იყოს 0-ზე მეტი",
    serviceAddSuccess: "სერვისი წარმატებით დაემატა",
    serviceUpdateSuccess: "სერვისი წარმატებით განახლდა",
    serviceDeleteSuccess: "სერვისი წარმატებით წაიშალა",
    failedToLoadServices: "სერვისების ჩატვირთვა ვერ მოხერხდა",
    failedToSaveService: "სერვისის შენახვა ვერ მოხერხდა",
    failedToDeleteService: "სერვისის წაშლა ვერ მოხერხდა",
    Monday: "ორშაბათი",
    Tuesday: "სამშაბათი",
    Wednesday: "ოთხშაბათი",
    Thursday: "ხუთშაბათი",
    Friday: "პარასკევი",
    Saturday: "შაბათი",
    Sunday: "კვირა",
    masterNote: "Master Note",
    addBooking: "დაჯავშნის დამატება",
    masterNoteLabel: "შენიშვნა",
    masterNotePlaceholder: "დაამატეთ შენიშვნა ამ ჯავშნისთვის (აუცილებელია)",
    masterNoteRequired: "გთხოვთ, დაამატოთ შენიშვნა ჯავშნისთვის",
    termsAgreement: "წავიკითხე და ვეთანხმები",
    termsOfService: "ვებსაიტის გამოყენების პირობები",
    termsAgreementRequired: "საჭიროა დაეთანხმოთ ვებსაიტის გამოყენების პირობებს"
  }
};

export default translations;
export { dateLocalization };
